<template>
  <div id="finish1" class="container">
    <div class="page-t">提交成功</div>
    <div class="row">
      <div>
        <i class="far fa-check-circle fa-6x"></i>
      </div>
      <div class="r1">订单提交成功</div>
      <div class="r2">我们将尽快为您发货，收货期间请保持手机畅通</div>
      <div class="r3">
        <span class="left">支付方式：</span>
        <span class="right">货到付款</span>
      </div>
      <div class="r4">
        <span class="left">支付金额：</span>
        <span class="right">&yen;1234.00</span>
      </div>
      <div class="r5">
        <router-link to="/">
          <el-button type="primary" @click="goIndex">返回首页</el-button>
        </router-link>
        <router-link to="/user/orders">
          <el-button>查看订单</el-button>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
    };
  },
  watch: {},
  created() {
    //
  },
  methods: {
    //
    goIndex() {
      this.$router.push("/");
    }
  }
};
</script>
<style lang="scss">
#finish1 {
  padding-bottom: 40px;
  .r5 {
    margin-bottom: 100px;
    button {
      width: 150px;
      margin: 0 20px;
    }
  }
  .r3 {
    margin-bottom: 20px;
  }
  .r4 {
    margin-bottom: 40px;
  }
  .r3,
  .r4 {
    .left {
      color: #999;
    }
    .right {
      color: #e2211c;
    }
  }
  .r2 {
    color: #666;
    font-size: 16px;
    margin-bottom: 20px;
  }
  .r1 {
    color: #666;
    font-size: 20px;
    margin-bottom: 20px;
  }
  .row {
    svg {
      color: #e2211c;
      margin: 70px 0 20px 0;
    }
    background-color: #ffffff;
    border: 1px solid #ddd;
    text-align: center;
  }
}
</style>